<div class="select-channel-container">
    <div *ngIf="!assignedChannel" class="select-button" (click)="openChannelSelector()" [class.disabled]="!userCanEdit">
        {{ 'integration.settings.status-color.channel-select' | translate }}
    </div>
</div>

<ng-container *ngIf="assignedChannel">
    <app-system-integration-channel
        [assignedChannel]="assignedChannel"
        (onRemoveChannel)="removeAssignedChannel()"
        (onOpenSelector)="openChannelSelector()"></app-system-integration-channel>
</ng-container>

<ng-container *ngIf="isGaugeElement">
    <app-gauge-element-settings
        #gaugeSettings
        [element]="selectedElement"
        [assignedChannel]="assignedChannel"
        [systemColors]="systemColors"
        [vessel]="vessel"></app-gauge-element-settings>
</ng-container>

<ng-container *ngIf="assignedChannel">
    <app-alarm-indicators
        #elementAlarms
        [assignedChannel]="assignedChannel"
        [activeFlags]="elementSettings?.activeFlags"
        [systemColors]="systemColors"
        [isMotorElement]="isMotorElement"></app-alarm-indicators>
</ng-container>

<ng-container *ngIf="!isComponent && !isGaugeElement && assignedChannel">
    <app-range-indicators
        #elementRanges
        [assignedChannel]="assignedChannel"
        [foreignObject]="selectedElement"
        [rangesArray]="elementSettings?.ranges"
        [userCanEdit]="userCanEdit"
        [systemColors]="systemColors"></app-range-indicators>
</ng-container>

<ng-container *ngIf="isLoadingChannel">
    <app-loading-spinner class="spinner-component"></app-loading-spinner>
</ng-container>
